const { useSelector, useDispatch } = require("react-redux");

export const useSelectorApp = (state) => useSelector(state);
export const useDispatchApp = () => useDispatch();
